






























import Vue from 'vue';
import { BRow, BCol, BButton } from 'bootstrap-vue';
import { find } from 'lodash';

import ZenMultiselect from '@reciprocity/multiselect';

import { ModelMetaSchema } from '@/types/apiTypes';

import { ObjectTypeDropdownOption } from '../types';

export default Vue.extend({
  name: 'ObjectTypeDropdown',
  components: {
    BButton,
    BRow,
    BCol,
    ZenMultiselect,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    exportableObjects: {
      type: Array as () => ModelMetaSchema[],
      required: true,
    },
  },
  computed: {
    exportableObjectOptions(): ObjectTypeDropdownOption[] {
      return this.exportableObjects.map((object: ModelMetaSchema) => ({
        label: object.titlePlural,
        id: object.modelSingular,
      }));
    },
    objectValue(): ObjectTypeDropdownOption {
      const objectValue = find(this.exportableObjectOptions, { id: this.value });
      return objectValue as ObjectTypeDropdownOption;
    },
  },
  methods: {
    updateValue(newValue: ObjectTypeDropdownOption) {
      this.$emit('input', newValue.id);
    },
  },
});
